import { FormPage } from './pages';

function Form() {
  return <FormPage />;
}

export default Form;
